import Vue from 'vue';
import App from './App.vue';
import i18n from "./translations/i18n";
import router from './router';
import store from "@/store/store";
import vuetify from './plugins/vuetify'
import validations from "@/helper/validations";
import VueAxios from "vue-axios";
import axios from 'axios';
import {initInterceptors} from "@/axios-interceptors";
import * as VueGoogleMaps from 'vue2-google-maps'
import LeaveConfirmDialog from "@/components/reusable/Dialog/LeaveConfirmDialog";

import TableAction from "@/components/reusable/DataTable/TableAction";
import { MazPhoneNumberInput } from 'maz-ui'
import 'maz-ui/lib/css/index.css'
import MapBasic from "@/components/MapBasic/MapBasic.vue";
import VSelect from "@/components/reusable/VuetifyOverrides/VSelect.vue";
Vue.config.productionTip = false;

Vue.prototype.$validations = validations;
Vue.use(VueAxios, axios);
Vue.component('TableAction',TableAction);
Vue.component('MazPhoneNumberInput',MazPhoneNumberInput);
Vue.component('LeaveConfirmDialog',LeaveConfirmDialog);
Vue.component('MapBasic',MapBasic);
Vue.component('VSelectCustom',VSelect);

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDG7NSnfjH4uxSVnkA6-4RcELgJsuobn8E'
  }});
initInterceptors();

new Vue({
  i18n,
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app');
Vue.component('VSelect',VSelect);